import React, { useContext } from 'react';

import { MainContext } from '../../store/context/main';
import { Container, ArrowUp } from './styles';
import { smoothScroll } from '../../utils/functions';

export default () => {
	const { state } = useContext(MainContext);

	return (
		<Container
			className={state.fixedMenu ? 'show' : ''}
			onClick={() => smoothScroll('#header')}
		>
			<ArrowUp />
		</Container>
	);
};
